import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import SweetAlert from 'react-bootstrap-sweetalert';

import { PanelPage } from '../../../components/pages/pages';
import Form from '../../../components/form/form';
import addNotification from '../../../components/notification';
import {
  getOutboundOrderCheckProductList,
  setOutboundRangeProductSelected,
} from '../../../app/store/actions/outboundOrderVolumes';
import OutboundConference from './outboundConference';

import WikiHelp from '../../../components/tooltip/wikiHelp';
import ROUTES from '../../../config/routes';

class OutboundOrderCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      baptismLabel: '',
      userPermission: false,
      blockBaptismField: false,
      fetchData: true,
      outboundOrderCheckProductList: [],
      outboundVolumeOpen: null,
      mainPackage: null,
      showShippingInstructionsAlert: false,
      shippingInstructions: '',
      customerName: '',
      orderNumber: '',
      pendingShippingInstructions: null,
      showOrderPickingInstructionsAlert: false,
      orderPickingInstructions: '',
      showProductNoteModal: false,
      usesQrCode: false,
      qrCodeConfig: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.fetchData && prevState.fetchData) {
      this.setState((currentState) => ({
        showShippingInstructionsAlert: !!currentState.pendingShippingInstructions,
        showOrderPickingInstructionsAlert: !!currentState.orderPickingInstructions,
        shippingInstructions: currentState.pendingShippingInstructions
          ? currentState.pendingShippingInstructions.shippingInstructions
          : '',
        customerName: currentState.pendingShippingInstructions
          ? currentState.pendingShippingInstructions.customerName
          : '',
        orderPickingInstructions: currentState.orderPickingInstructions || '',
        orderNumber: currentState.orderNumber || '',
        pendingShippingInstructions: null,
      }));
    }
  }

  setValue = async (attr, value) => {
    const { blockBaptismField, userPermission } = this.state;

    this.setState({
      [`${attr}`]: value,
      blockBaptismField: (attr === 'baptismLabel' && value === '' && userPermission)
        ? false
        : blockBaptismField,
    });
  };

  resetForm = async () => {
    this.setState({
      baptismLabel: '',
      userPermission: false,
      blockBaptismField: false,
      fetchData: true,
      outboundOrderCheckProductList: [],
      outboundVolumeOpen: null,
      mainPackage: null,
      showShippingInstructionsAlert: false,
      shippingInstructions: '',
      customerName: '',
      pendingShippingInstructions: null,
      showOrderPickingInstructionsAlert: false,
      orderPickingInstructions: '',
      usesQrCode: false,
      qrCodeConfig: null,
    });
  };

  keydownSendConfirmCheck = (e) => {
    if (e.keyCode === 13) this.searchConferenceProducts();
  };

  searchConferenceProducts = async () => {
    const { baptismLabel } = this.state;

    if (baptismLabel === '') {
      document.getElementById(1).focus();
      document.getElementById(1).select();
      addNotification(
        'danger',
        I18n.t('BEE37' /* Conferência */),
        I18n.t('BEE1555' /* Campo (Batismo) deve ser informado. */),
        'top-right',
      );
    } else {
      try {
        const result = await this.props.getOutboundOrderCheckProductList(baptismLabel);

        if (!result || result.success === false) {
          addNotification(
            'danger',
            I18n.t('BEE37' /* Conferência */),
            I18n.t('BEE1870' /* Erro ao localizar o batismo */),
            'top-right',
          );
        } else if (!result.listOutboundRangeProducts || result.listOutboundRangeProducts.length === 0) {
          addNotification(
            'danger',
            I18n.t('BEE37' /* Conferência */),
            I18n.t('BEE4401' /* Não há produtos pendentes de conferência relacionados a esta UZ. */),
            'top-right',
          );
        } else {
          const { shippingInstructions, orderPickingInstructions } = result;
          const hasShippingInstructions = shippingInstructions && shippingInstructions.trim() !== '';
          const hasOrderPickingInstructions = orderPickingInstructions && orderPickingInstructions.trim() !== '';

          this.setState({
            blockBaptismField: true,
            outboundOrderCheckProductList: result.listOutboundRangeProducts,
            orderNumber: result.listOutboundRangeProducts[0].orderNumber,
            outboundVolumeOpen: result.outboundVolumeOpen,
            mainPackage: result.mainPackage,
            fetchData: false,
            ...(hasShippingInstructions && {
              pendingShippingInstructions: {
                shippingInstructions,
                customerName: result.outboundVolumeOpen?.customerOrderName || '',
              },
            }),
            ...(hasOrderPickingInstructions && {
              orderPickingInstructions,
            }),
            usesQrCode: result.usesQrCode,
            qrCodeConfig: result.qrCodeConfig,
          });
        }
      } catch (error) {
        const messageError = error.response && error.response.data
          && error.response.data.error && error.response.data.error.message;

        if (messageError) {
          addNotification(
            'danger',
            I18n.t('BEE37' /* Conferência */),
            messageError,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE37' /* Conferência */),
            I18n.t('BEE1870' /* Erro ao localizar o batismo */),
            'top-right',
          );
        }
      }
    }
  };

  createInput = (
    value,
    attr,
    label,
    placeholder,
    type = 'text',
    required,
    disabled,
    keypressFunction = undefined,
    id = null,
  ) => (
    <div className="form-group text-left">
      <span>{label}</span>
      <div className="input-group">
        <input
          onKeyDown={keypressFunction && ((e) => keypressFunction(e, id, attr))}
          id={id && id}
          type={type}
          className="form-control"
          value={value || ''}
          onChange={(e) => this.setValue(attr, e.target.value)}
          placeholder={disabled ? '' : placeholder}
          required={required}
          disabled={disabled}
        />
        {!disabled && (
          <div className="input-group-append">
            <button type="button" className="btn btn-secondary" onClick={() => this.setValue(attr, '')}>
              <i className="fa fa-times" />
              {' '}
            </button>
          </div>
        )}
      </div>
    </div>
  );

  confirmShippingInstructions = () => {
    this.setState(() => ({
      showShippingInstructionsAlert: false,
    }));
  };

  showShippingInstructionsAlert = () => {
    this.setState(() => ({
      showShippingInstructionsAlert: true,
    }));
  };

  confirmOrderPickingInstructions = () => {
    this.setState(() => ({
      showOrderPickingInstructionsAlert: false,
    }));
  };

  showOrderPickingInstructions = () => {
    this.setState(() => ({
      showOrderPickingInstructionsAlert: true,
    }));
  };

  confirmProductNoteModal = () => {
    this.setState(() => ({
      showProductNoteModal: false,
    }));
  };

  showProductNoteModal = () => {
    if (this.props.productSelected && this.props.productSelected.note) {
      this.setState(() => ({
        showProductNoteModal: true,
      }));
    }
  };

  render() {
    const {
      baptismLabel, blockBaptismField, fetchData, outboundOrderCheckProductList, outboundVolumeOpen,
      mainPackage, showShippingInstructionsAlert, shippingInstructions, customerName, showOrderPickingInstructionsAlert,
      orderPickingInstructions, orderNumber, showProductNoteModal,
    } = this.state;

    return (
      <>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1400' /* Movimentação */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE41' /* Expedição */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE37' /* Conferência */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center">
          <h1 className="page-header mb-0">
            {I18n.t('BEE37' /* Conferência */)}
          </h1>
          <WikiHelp wikiPath={ROUTES.OUTBOUND_CHECK_HELP} />
        </div>
        {fetchData && (
          <div onSubmit={(e) => e.preventDefault()}>
            <PanelPage
              noButton
              content={(
                <div className="col-md-4">
                  <Form
                    noPanel
                    leftType
                    setValue={this.setValue}
                    inputs={(formContext) => ([
                      formContext.createInputButton(
                        baptismLabel,
                        'baptismLabel',
                        I18n.t('BEE425' /* Batismo */),
                        '',
                        'text',
                        false,
                        blockBaptismField,
                        <i className="fa fa-search" />,
                        this.searchConferenceProducts,
                        this.keydownSendConfirmCheck,
                        1,
                      ),
                    ])}
                  />
                </div>
              )}
              footerContent={(
                <button
                  type="button"
                  className="btn btn-120 btn-primary p-5 m-5"
                  onClick={this.searchConferenceProducts}
                >
                  {I18n.t('BEE407' /* Buscar */)}
                </button>
              )}
            />
          </div>
        )}
        {!fetchData && (
          <OutboundConference
            searchConferenceProducts={() => this.searchConferenceProducts()}
            outboundOrderCheckProductList={outboundOrderCheckProductList}
            outboundVolumeOpen={outboundVolumeOpen}
            mainPackage={mainPackage}
            resetForm={() => this.resetForm()}
            shippingInstructions={shippingInstructions}
            orderPickingInstructions={orderPickingInstructions}
            customerName={customerName}
            onShowShippingInstructions={this.showShippingInstructionsAlert}
            onConfirmShippingInstructions={this.confirmShippingInstructions}
            onShowOrderPickingInstructions={this.showOrderPickingInstructions}
            onShowProductNoteModal={this.showProductNoteModal}
            onConfirmProductNoteModal={this.confirmProductNoteModal}
            usesQrCode={this.state.usesQrCode}
            qrCodeConfig={this.state.qrCodeConfig}
          />
        )}

        {showShippingInstructionsAlert && (
          <SweetAlert
            warning
            confirmBtnText={I18n.t('BEE4417' /* Confirmar Leitura */)}
            confirmBtnBsStyle="warning"
            title={I18n.t('BEE4415' /* Instruções de Expedição */)}
            onConfirm={this.confirmShippingInstructions}
          >
            <div>
              <p>
                <strong>
                  {I18n.t('BEE50' /* Cliente */)}
                  :
                  {' '}
                  {customerName}
                </strong>
              </p>
              <p>
                {I18n.t('BEE4415' /* Instruções de Expedição */)}
                :
              </p>
              <div
                style={{
                  backgroundColor: '#f8f9fa',
                  padding: '10px',
                  border: '1px solid #dee2e6',
                  borderRadius: '4px',
                  marginTop: '10px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {shippingInstructions}
              </div>
            </div>
          </SweetAlert>
        )}
        {showOrderPickingInstructionsAlert && (
          <SweetAlert
            warning
            confirmBtnText={I18n.t('BEE4417' /* Confirmar Leitura */)}
            confirmBtnBsStyle="warning"
            title={I18n.t('BEE4478' /* Observações do documento */)}
            onConfirm={this.confirmOrderPickingInstructions}
          >
            <div>
              <p>
                <strong>
                  {I18n.t('BEE1027' /* Número do Documento */)}
                  :
                  {' '}
                  {orderNumber}
                </strong>
              </p>
              <p>
                {I18n.t('BEE4478' /* Observações do documento */)}
                :
              </p>
              <div
                style={{
                  backgroundColor: '#f8f9fa',
                  padding: '10px',
                  border: '1px solid #dee2e6',
                  borderRadius: '4px',
                  marginTop: '10px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {orderPickingInstructions}
              </div>
            </div>
          </SweetAlert>
        )}
        {(showProductNoteModal
          && (
            <SweetAlert
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="primary"
              title={I18n.t('BEE135' /* Observação */)}
              onConfirm={() => {
                this.setState({
                  showProductNoteModal: false,
                });
              }}
              onCancel={() => {
                this.setState({
                  showProductNoteModal: false,
                });
              }}
            >
              <>
                <div className="row">
                  <div className="col-6">
                    {this.createInput(
                      orderNumber,
                      'orderNumber',
                      I18n.t('BEE443' /* Documento */),
                      '',
                      'text',
                      false,
                      true,
                    )}
                  </div>
                  <div className="col-6">
                    {this.createInput(
                      this.props.productSelected.productCode,
                      'productCode',
                      I18n.t('BEE1999' /* Código Produto */),
                      '',
                      'text',
                      false,
                      true,
                    )}
                  </div>
                </div>
                <div className="text-left pt-2">
                  <span>{I18n.t('BEE135' /* Observação */)}</span>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={this.props.productSelected.note || ''}
                    disabled
                  />
                </div>
              </>
            </SweetAlert>
          ))}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  productSelected: state.outboundOrderVolumes.productSelected,
});

const mapDispatchToProps = (dispatch) => ({
  getOutboundOrderCheckProductList: (baptismLabel) => dispatch(getOutboundOrderCheckProductList(baptismLabel)),
  setOutboundRangeProductSelected: (productSelected) => dispatch(setOutboundRangeProductSelected(productSelected)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundOrderCheck));
